export default __webpack_public_path__ + "static/media/hospital.9d564696.svg";